import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Language, LANGUAGES } from 'src/app/core/constants/language-and-locale-constants';
import { MobileSolutionsMenuComponent } from 'src/app/components/mobile-solutions-menu/mobile-solutions-menu.component';
@Component({
  selector: 'emp-mobile-account-menu',
  templateUrl: './mobile-account-menu.component.html',
  styleUrls: ['./mobile-account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, CommonModule, TranslatePipe, MobileSolutionsMenuComponent]
})
export class MobileAccountMenuComponent {
  public authService = inject(AuthService);
  public languageService = inject(LanguageService);

  public languages = LANGUAGES;

  public changeLanguage(language: Language): void {
    this.languageService.setLanguage(language);
  }
}
